import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "@mui/material/Link";

export const CommunityIconButton = (props: any) => (
  <Link
    sx={{ color: '#949494', aspectRatio: "1" }}
    href={props.href}>
    <img src={props.icon} style={{ width: 36, aspectRatio: "1" }} />
  </Link>
)